// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CLIENTES_CLEAR_LISTA_DE_CLIENTES,
} from './constants';

export function clearListaDeClientes() {
  return {
    type: CLIENTES_CLEAR_LISTA_DE_CLIENTES,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_CLEAR_LISTA_DE_CLIENTES:
      return {
        ...state,
        dataList: null,
        getListaDeClientesPending: false,
        getListaDeClientesError: null,
      };

    default:
      return state;
  }
}
